import * as actionTypes from './actionTypes';
import axios from '../../axios/Backend';

const fetchContactsStart = () => {
    return (
        {
            type: actionTypes.FETCH_CONTACTS_START
        }
    );
};

const fetchContactsSuccess = (contacts) => {
    return (
        {
            type: actionTypes.FETCH_CONTACTS_SUCCESS,
            contacts
        }
    );
};

const fetchContactsFail = (errorContacts) => {
    return (
        {
            type: actionTypes.FETCH_CONTACTS_FAIL,
            errorContacts
        }
    );
};

export const fetchContacts = (contain = '', numberOfCallsToFetch, startIndex) => {
    return async dispatch => {
        try {
            dispatch(fetchContactsStart());
            const paginationString = numberOfCallsToFetch > -1 && startIndex > -1 && `&page=${Math.floor(startIndex / numberOfCallsToFetch) + 1}&limit=${numberOfCallsToFetch}`

            const resData = await axios.get(`/api/v2/contacts?sort=+fullName&searchKey=${contain ? contain : ''}${paginationString ? paginationString : ''}`);

            const data = resData.data;

            dispatch(fetchContactsSuccess(data));
        } catch (e) {
            dispatch(fetchContactsFail(e.message));
            console.log(e.message);
        }
    };
};

export const selectContactSuccess = (contactId) => {

    return {
        type: actionTypes.SELECT_CONTACT_SUCCESS,
        contactId
    }
}

export const insertContact = (contact)=>{
    return {
        type : actionTypes.INSERT_NEW_CONTACT,
        contact
    }
}

export const updateContact = (contact)=>{
    return {
        type : actionTypes.UPDATE_CONTACT,
        contact
    }
}

export const deleteContact = (contact)=>{
    return {
        type : actionTypes.DELETE_CONTACT,
        contact
    }
}